import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Inject,
  ElementRef,
  Renderer2,
  HostListener,
  ViewEncapsulation,
} from "@angular/core";
import { BasePageComponent } from "../base-page";
import { Store } from "@ngrx/store";
import { IAppState } from "../../interfaces/app-state";
import { HttpService } from "../../services/http/http.service";
import { Content } from "../../ui/interfaces/modal";
import { TCModalService } from "../../ui/services/modal/modal.service";
import Swal from "sweetalert2";
import swal from "sweetalert2";
import { HttpErrorResponse, HttpClient } from "@angular/common/http";
import { MainService } from "./main.service";
import { Spinkit } from "ng-http-loader"; // <============
import { Router } from "@angular/router";
import { element } from "protractor";
import { ADDon } from "./main.model";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { switchAll } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { STATUS_CODES } from "http";
import { PdfServiceService } from "src/app/pdf-service.service";

// import { IOption } from '../../../../ui/interfaces/option';
@Component({
  selector: "page-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  providers: [MainService],
})
export class MainPageComponentnt
  extends BasePageComponent
  implements OnInit, OnDestroy {
  searchTerm: string = '';
  restoID;
  data = [];
  public spinkit = Spinkit;
  public file: any;
  public imageFile: any;
  restoDeatils = [];
  mapOfExpandData: { [key: string]: boolean } = {};
  rstoName;
  rstoID;
  rstoAdd;
  rstopocName;
  pocID;
  rstoEmail;
  values;
  restaurant_id;
  switchs;
  showAction: boolean = false;
  Acces;
  mineActiveOrnot;
  restoDeatilsMine = [];
  activetoggle;
  algns: any = [];
  addonListarray = [];
  allArray: any = [];
  dietArray: any = [];
  dietPref = [];
  tagmultiple: any = [];
  tagArray = [];
  categories = [];
  alrgOptionarray = [];
  alrgoption = [];
  dietOption = [];
  dietoptinarray = [];
  aalreges;
  dietPrefs;
  tagsadd;
  alergoption;
  dietprefoption;
  ingredience;
  optionsName_value;
  description;
  show_Modal_detail: boolean = false;
  disablesFileaudio;
  food_dishes_price;
  food_dishes_id;
  food_dishes_restaurant_id;
  errorMessage;
  allergensWithCommaview;
  dietpreference;
  allergens = [];
  resto = [];
  food_dishes_name;
  food_dishes_spice_rating;
  food_dishes_calories;
  food_dishes_category_id;
  filesk = {};
  currentAvatar;
  tag_id;
  dietPrefOp;
  allergeOp;
  tagview;
  last_update;
  restaurant_image;
  messageFilesize;
  disablesFile;
  disablesCsv;
  qrCodeurl;
  restaurant_service_charge;
  CC;
  tableDeatils: any;
  tableId: any;
  restaurant_coupan_value: any;
  web_table_id: any;
  r_id: any;
  imgurl: any;
  allergens_value: any;
  duration: any;
  audioFile: any;
  currentAudio: any;
  audio_file: any;
  file_name: string;
  allergens_words;
  count;
  option_price;
  dishID;
  optionsName = [];
  rdo_id;
  serverData = [];
  option_name;
  dynamicArray = [];
  delete_id: any;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  myForm: FormGroup;
  addon_name;
  addon_price;
  submitted: boolean = false;
  logo: string

  rda_addon_ids: any;
  rdo_option_addOn_price: any;
  check = "red";
  colors = ["red", "yellow", "green"];
  text = 'Varients'
  foodMenuLink: any

  navigateToMaster() {
    this.router.navigate(['/details/masterRestoDetails'])
  }


  condition = false
  constructor(
    store: Store<IAppState>,
    public httpSv: HttpService,
    private mainservice: MainService,
    private modal: TCModalService,
    private popup_modal: TCModalService,
    private router: Router,
    private httpClient: HttpClient,
    private fb: FormBuilder,
    private detectChange: ChangeDetectorRef,
    private dialog: MatDialog,
    private toster: ToastrService
  ) {
    super(store, httpSv);
    this.pageData = {
      title: "",
      loaded: true,
      breadcrumbs: [
        {
          title: "Main",
        },
      ],
    };
  }
  qrCodeDownload: boolean = true;
  back_flag: boolean = false;
  ngOnInit() {

    console.log('new build........')

    this.restoID = localStorage.getItem("restoID");
    super.ngOnInit();
    if (localStorage.getItem('master_user') == 'true') {
      this.back_flag = true
    }

    this.getdata();
    this.getrestoDetails();
    this.getTabledetail();
    this.myForm = this.fb.group({
      persons: this.fb.array([]),
    });

    this.secondFormGroup = this.fb.group({
      rda_addon_id: [""],
      dishOptions: this.fb.array([this.createElement()]),
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  createElement(): FormGroup {
    return this.fb.group({
      option_name: [""],
      rdo_option_addOn_price: ["", [Validators.required]],
    });
  }
  getdata() {
    this.httpSv.getReturant(this.restoID).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.resto = response["result"].data;
          this.rstoName = this.resto["restaurant_name"];
          this.rstoID = this.resto["restaurant_unique_id"];
          this.rstoAdd = this.resto["restaurant_address"];
          this.rstopocName = this.resto["restaurant_poc_name"];
          this.pocID = this.resto["restaurant_poc_number"];
          this.rstoEmail = this.resto["restaurant_email"];
          this.restaurant_id = this.resto["restaurant_id"];
          this.restaurant_image = this.resto["restaurant_image"];
          this.restaurant_service_charge =
            this.resto["restaurant_service_charge"];
          this.restaurant_coupan_value = this.resto["restaurant_coupan_value"];
          this.logo = this.resto['logo']
          this.foodMenuLink = this.resto['qr_code_link']
          if (this.resto['level_of_restaurant'] == 'L0' || this.resto['level_of_restaurant'] == 'L1') {
            this.qrCodeDownload = true
          }
          else this.qrCodeDownload = false
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }
  getrestoDetails() {
    this.httpSv.getReturantDetails(this.restoID).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.restoDeatils = response["result"].data;


          // this.restoDeatils[0].allergens[0].allergens_id = '0'
        }
        this.getAllMenuName();
      },
      (err: HttpErrorResponse) => {
        this.getAllMenuName();
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  allActiveMenuName = [];
  allMenuName = [];
  isDefaultMenu: boolean = true;
  dishesWithMenuName = null;
  selectedMenuName: any;
  getAllMenuName() {
    this.httpSv.getReturantAllMenuName(this.restoID).subscribe(
      (response) => {
        if (response["status"] == true) {
          if (response["result"].data.length == 1 && response["result"].data[0].dish_menu_name == 'Default')
            return
          this.allMenuName = response["result"].data;

          if (this.allMenuName.length > 0) {
            this.allActiveMenuName = this.allMenuName.filter((ele) => ele.dish_menu_status == 'Active')
            this.isDefaultMenu = false;
            let tempData = {}
            this.allActiveMenuName.forEach((element) => {
              tempData[element.id] = []
            });
            this.restoDeatils.forEach((element) => {
              console.log(element)
              tempData[element.menu_names_id]?.push(element)
            });
            this.dishesWithMenuName = tempData
            this.selectedMenuName = this.allActiveMenuName[0].id
            this.changeDisheTableMenu(this.allActiveMenuName[0].id)
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }



  changeDisheTableMenu(menuId) {
    console.log(this.dishesWithMenuName)
    this.restoDeatils = [...this.dishesWithMenuName[menuId]]
    this.detectChange.detectChanges()
    console.log(this.restoDeatils)
  }
  getTabledetail() {
    this.httpSv.getTabledetail().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.tableDeatils = response["result"].data;
          this.tableId = response["result"].data.restaurant_table_id;
          const result = this.tableDeatils.filter(
            (s) => s.restaurant_table_name == "Web"
          );
          result.forEach((element) => {
            element.restaurant_table_id;
            this.web_table_id = element.restaurant_table_id;
            this.r_id = element.restaurant_table_r_id;
            this.downLoadQrWebImage();
          });
        } else {
          Swal.fire("Something Went Wrong");
          this.tableDeatils;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  downloadImage(img) {
    const imgUrl = img.src;
    const imgName = imgUrl.substr(imgUrl.lastIndexOf("/") + 1);
    this.httpClient
      .get(imgUrl, { responseType: "blob" as "json" })
      .subscribe((res: any) => {
        const file = new Blob([res], { type: res.type });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
        }
        const blob = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = blob;
        link.download = imgName;
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        setTimeout(() => {
          // firefox
          window.URL.revokeObjectURL(blob);
          link.remove();
        }, 100);
      });
  }
  generateQrcode() {
    this.mainservice.generateQrcode(this.restoID).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.qrCodeurl = response["result"].data.url;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  logout() {
    this.httpSv.logout().subscribe(
      (response) => {
        localStorage.clear();
        setTimeout(() => {
          this.router.navigate(["/public/sign-in"]);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
  downLoadQrWebImage() {
    this.httpSv.downLoadQr(this.web_table_id, this.r_id).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.imgurl = response["result"].data.url;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  downLoadQrWeb(flag: boolean = false) {
    this.httpSv.downLoadQr(this.web_table_id, this.r_id).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.imgurl = response["result"].data.url;
          if (flag) {
            this.imgurl = this.imgurl.replace('/qr/', '/qr/qr_codes/');
          }

          const imgName = this.imgurl.substr(this.imgurl.lastIndexOf("/") + 1);
          this.httpClient
            .get(this.imgurl, { responseType: "blob" as "json" })
            .subscribe((res: any) => {
              const file = new Blob([res], { type: res.type });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
                return;
              }
              const blob = window.URL.createObjectURL(file);
              const link = document.createElement("a");
              link.href = blob;
              link.download = imgName;
              link.dispatchEvent(
                new MouseEvent("click", {
                  bubbles: true,
                  cancelable: true,
                  view: window,
                })
              );
              setTimeout(() => {
                window.URL.revokeObjectURL(blob);
                link.remove();
              }, 100);
            });
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  allDiestpref = [];
  getDiestpref() {
    this.httpSv.getallActiveRestoDiestpref().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.allDiestpref = response["result"].data;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }
  algns_name;
  getAllergens() {
    this.httpSv.getallActiveRestoAllergens().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.allergens = response["result"].data;
          // this.allergens.unshift({allergens_id:"0",allergens_name: "None"})
          this.allergens.forEach((element) => {
            this.algns_name = element.allergens_name;
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }
  getCategory() {
    this.mainservice.getallCategory(this.restoID).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.categories = response["result"].data;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }
  tags = [];
  getTag() {
    this.httpSv.getTag().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.tags = response["result"].data;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }

  // open modal window
  openModals<T>(
    body: Content<T>,
    header: Content<T> = null,
    footer: Content<T> = null,
    options: any = null,
    value
  ) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
    });
    const _modal: any = document.querySelector("tc-modal");
    _modal.remove();
    this.getCategory();
    this.getAllergens();
    this.getDiestpref();
    this.getTag();
    // this.algns = []
    // this.allArray = []
    // this.dietArray = []
    // this.dietPref = []
    // this.tagmultiple = []
    // this.tagArray = []
    // this.alrgOptionarray = []
    // this.alrgoption = []
    // this.dietOption = [];
    // this.dietoptinarray = []
    // this.food_dishes_id = value.food_dishes_id;
    // this.food_dishes_restaurant_id = value.food_dishes_restaurant_id
    // this.food_dishes_name = value.food_dishes_name;
    // this.food_dishes_price = value.food_dishes_price;
    // this.food_dishes_spice_rating = value.food_dishes_spice_rating
    // this.food_dishes_calories = value.food_dishes_calories
    // this.food_dishes_category_id = value.food_dishes_category_id
    // this.ingredience = value.food_dishes_ingredients
    // this.description = value.food_dishes_details
    // this.allArray = value.allergens
    // this.tagmultiple = value.tagList;
    // this.dietArray = value.diet_preference
    // this.alrgOptionarray = value.allergensOption
    // this.dietoptinarray = value.diet_preference_option;
    // this.tagmultiple.forEach(element => {
    //   this.tagArray.push(element.tag_id)
    // });
    // this.allArray.forEach(element => {
    //   this.algns.push(element.allergens_id)
    // });
    // this.dietArray.forEach(element => {
    //   this.dietPref.push(element.diet_preference_id)
    // });
    // this.alrgOptionarray.forEach(element => {
    //   this.alrgoption.push(element.allergens_id)
    // });
    // this.dietoptinarray.forEach(element => {
    //   this.dietOption.push(element.diet_preference_id)
    // });
  }
  addons = [];
  options = [];

  openModalsView<T>(
    body: Content<T>,
    header: Content<T> = null,
    footer: Content<T> = null,
    options: any = null,
    value
  ) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
    });
    this.getCategory();
    this.getAllergens();
    this.getDiestpref();
    this.getTag();
    this.algns = [];
    this.allArray = [];
    this.dietArray = [];
    this.dietPref = [];
    this.allergeOp = [];
    this.alrgoption = [];
    this.dietpreference = [];
    this.allergens_words = [];
    this.dietPrefOp = [];
    this.tagview = [];
    this.dietOption = []
    console.log(value)
    if (value.dpWithComma) {
      this.dietpreference = value.diet_preference.map((ele: any) => ele.diet_preference_name).join(",");
    }
    this.alrgoption = value.allergensOption.map((ele: any) => ele.food_dishes_ao_type_id)
    this.allergens_value = value.allergensWithComma;
    if (this.allergens_value) {
      let tAlergen: any = value.allergens.map((ele: any) => ele.allergens_name)
      this.allergens_words = tAlergen.join(",");
    }
    this.food_dishes_id = value.id;
    this.food_dishes_restaurant_id = value.restaurant_id;
    this.food_dishes_name = value.name;
    this.food_dishes_price = value.price;
    this.food_dishes_spice_rating = value.spice_rating;
    this.food_dishes_calories = value.calories;
    this.food_dishes_category_id = value.dish_type_id;
    this.tag_id = value.tag_id;
    this.last_update = value.updated_on;
    this.ingredience = value.ingredients;
    this.description = value.description;
    this.allArray = value.allergens;
    if (value.dpoWithComma) {
      this.dietPrefOp = value.diet_preference_option.map((ele: any) => ele.diet_preference_name).join(",");
    }
    if (value.allergensOptionWithComma) {
      this.allergeOp = value.allergensOption.map((ele: any) => ele.allergens_name).join(",");
    }
    if (value.tagWithComma) {
      this.tagview = value.tagList.map((ele: any) => ele.tag_name).join(",");
    }
    this.CC = value.food_dishes_iscc;
    this.allArray.forEach((element) => {
      this.algns.push(element.allergens_id);
    });
    this.dietArray = value.diet_preference;
    this.dietArray.forEach((element) => {
      this.dietPref.push(element.diet_preference_id);
    });
    let dietoptinarrayTemp = value.diet_preference_option;
    dietoptinarrayTemp.forEach(element => {
      this.dietOption.push(element.diet_preference_id)
    });
    this.httpSv.dishAddon(this.food_dishes_id).subscribe((res) => {
      if (res["status"] == true) {
        this.addons = res["result"].AddOn;
        this.options = res["result"].optionsName;
      }
    });
  }
  dishes_id;
  openModal<T>(
    body: Content<T>,
    header: Content<T> = null,
    footer: Content<T> = null,
    value
  ) {
    this.dishes_id = value;
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
  }

  id;

  openModalDelete<T>(
    body: Content<T>,
    header: Content<T> = null,
    footer: Content<T> = null,
    id
  ) {
    this.dishes_id = this.food_dishes_id;
    this.delete_id = id;
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
  }

  closeModal() {
    this.text = 'Varients'
    this.modal.close();
  }
  closeModals() {
    this.text = 'Varients'
    this.modal.close();
    const _modal: any = document.querySelector("tc-modal");
    _modal.remove();
  }
  closeModalView() {
    this.text = 'Varients'
    this.modal.close();
    const _modal: any = document.querySelector("tc-modal");
    _modal.remove();
  }
  openModalImage<T>(
    header: Content<T> = null,
    body: Content<T>,
    options: any = null,
    value
  ) {
    this.currentAvatar = "";
    this.food_dishes_id = value.id;
    this.currentAvatar = value.food_dishes_image;
    this.audio_file = value.food_dishes_audio;
    this.modal.open({
      body: body,
      header: header,
      options: options,
    });
  }

  openModalAudio<T>(
    header: Content<T> = null,
    body: Content<T>,
    footer: Content<T> = null,
    value
  ) {
    this.currentAudio = "";
    this.food_dishes_id = value.id;
    this.audio_file = value.food_dishes_audio;
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
  }

  switch(valueStatus, valueId) {
    this.httpSv
      .AcitveInactiveDish(valueStatus, this.restaurant_id, valueId)
      .subscribe(
        (response) => {
          if (response["status"] == true) {
            this.text = 'Varients'
            this.modal.close();
            this.getrestoDetails();
          }
        },
        (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      );
  }

  switchRecomanded(valueStatus, valueId) {
    this.httpSv
      .AcitveRecomandedDish(valueStatus, this.restaurant_id, valueId)
      .subscribe(
        (response) => {
          if (response["status"] == true) {
          }
        },
        (err: HttpErrorResponse) => {
          this.errorMessage = err;
          this.modal.close();
          this.text = 'Varients'
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      );
  }

  switchCC(valueStatus, valueId) {
    this.httpSv
      .AcitvecrossContamination(valueStatus, this.restaurant_id, valueId)
      .subscribe(
        (response) => {
          if (response["status"] == true) {
            // alert("success")
          }
        },
        (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      );
  }

  switchCustomize(valueStatus, valueId) {
    this.httpSv
      .AcitveCustomizeDish(valueStatus, this.restaurant_id, valueId)
      .subscribe(
        (response) => {
          if (response["status"] == true) {
            this.getrestoDetails();
          }
        },
        (err: HttpErrorResponse) => {
          this.errorMessage = err;
          this.modal.close();
          this.text = 'Varients'
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      );
  }

  deleteDish() {
    this.httpSv.deleteDish(this.food_dishes_id, this.restaurant_id).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.modal.close();
          this.text = 'Varients'
          this.closeModalView();
          swal.fire({
            titleText: "Deleted Successfully",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        this.modal.close();
        this.text = 'Varients'
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    );
  }
  updateDish() {
    this.httpSv.deleteDish(this.values, this.restaurant_id).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.modal.close();
          this.text = 'Varients'
          swal.fire({
            titleText: response["message"],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.modal.close();
        this.text = 'Varients'
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
      }
    );
  }
  updateList(
    food_dishes_name,
    food_dishes_price,
    food_dishes_spice_rating,
    food_dishes_calories,
    food_dishes_category_id,
    algns,
    dietPref,
    Ingredience,
    Description,
    tagArray,
    alrgoption,
    dietOption
  ) {
    console.log('//////', alrgoption)
    this.aalreges = algns.map((allergens_id) => ({ allergens_id }));
    this.dietPrefs = dietPref.map((diet_preference_id) => ({
      diet_preference_id,
    }));
    this.tagsadd = tagArray.map((tag_id) => ({ tag_id }));
    this.alergoption = alrgoption.map((allergens_id) => ({ allergens_id }));
    this.dietprefoption = dietOption.map((diet_preference_id) => ({
      diet_preference_id,
    }));
    const data = {
      food_dishes_id: this.food_dishes_id,
      food_dishes_restaurant_id: this.food_dishes_restaurant_id,
      food_dishes_category_id: food_dishes_category_id,
      food_dishes_name: food_dishes_name,
      food_dishes_details: Description,
      food_dishes_ingredients: Ingredience,
      food_dishes_price: food_dishes_price,
      food_dishes_calories: food_dishes_calories,
      food_dishes_spice_rating: food_dishes_spice_rating,
      allergens: this.aalreges,
      diet_preference: this.dietPrefs,
      taglist: this.tagsadd,
      allergens_option_available: this.alergoption,
      dietry_preference_option: this.dietprefoption,
    };
    this.httpSv.updateList(data).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.closeModalView();
          swal.fire({
            titleText: response["message"],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.modal.close();
        this.text = 'Varients'
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
      }
    );
  }
  noRecordMsgFlag: boolean;
  isEmpty(event) {
    if (event.filteredValue.length == 0) {
      this.noRecordMsgFlag = true;
    } else {
      this.noRecordMsgFlag = false;
    }
  }
  openModalFile<T>(
    header: Content<T> = null,
    body: Content<T>,
    footer: Content<T> = null,
    options: any = null
  ) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
    });
  }
  formatData;
  onCSVChange(event) {
    if (event.target.files && event.target.files[0]) {
      this.filesk = event.target.files[0];
    }
  }
  uploadCsv() {
    this.mainservice.addList(this.restaurant_id, this.filesk).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.modal.close();
          this.text = 'Varients'
          swal.fire({
            titleText: response["message"],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
        this.modal.close();
        this.text = 'Varients'
      }
    );
  }

  downloadTemplate() {
    this.httpSv.getCsvTempData(this.restaurant_id).subscribe(
      (response) => {
        if (response) {
          let csvFile = response["result"].data.url;
          let splittedUrl = csvFile.split("www/");
          this.downloadFile(csvFile);
          // this.httpSv.deleteCsvFile(splittedUrl[1]).subscribe((res:any)=> {
          // })
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
      }
    );
  }
  downloadFile(urlData) {
    var aLink = document.createElement("a");
    aLink.href = urlData;
    var event = new MouseEvent("click");
    aLink.dispatchEvent(event);
    aLink.remove();
  }

  // upload new file
  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round(fsize / 1024);
      if (fileSize < 2048) {
        this.imageFile = new FormData();
        this.imageFile.append("file", event.target.files[0]);
        this.imageFile.append("id", this.restaurant_id);
        this.imageFile.append("dish_id", this.food_dishes_id);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize = "";
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.messageFilesize =
          "File too Big, please select a file less than 2mb";
      }
      // this.imageFile.forEach((key, value) => {
      //   console.log(key, value);
      // });
    }
  }
  onaudioChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round(fsize / 1024);
      if (fileSize < 2048) {
        this.audioFile = new FormData();
        this.audioFile.append("file", event.target.files[0]);
        this.audioFile.append("id", this.restaurant_id);
        this.audioFile.append("dish_id", this.food_dishes_id);
        let file: File = event.target.files[0];
        this.file_name = file.name;
        let reader: FileReader = new FileReader();
        this.messageFilesize = "";
        reader.onloadend = () => {
          this.uploadAudio_show();
          this.currentAudio = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.messageFilesize =
          "File too Big, please select a file less than 2mb";
      }
    }
  }
  uploadImage() {
    // console.log("from sub", this.imageFile);
    this.httpSv.addImage(this.imageFile).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.closeModals();
          swal.fire({
            titleText: response["message"],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
        this.modal.close();
        this.text = 'Varients'
      }
    );
  }
  uploadAudio_show() {
    this.httpSv.uploadDishAudio(this.audioFile).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.audio_file = response["result"].data.url;
          this.ngOnInit();
        }
      },
      (err: HttpErrorResponse) => { }
    );
  }
  uploadAudio() {
    this.httpSv.uploadDishAudio(this.audioFile).subscribe(
      (response) => {
        if (response["status"] == true) {
          this.closeModals();
          swal.fire({
            titleText: response["message"],
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
          this.router
            .navigateByUrl("/", { skipLocationChange: true })
            .then(() => {
              this.router.navigate(["/horizontal/main"]);
            });
          this.getrestoDetails();
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.message;
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
        this.text = 'Varients'
        this.modal.close();
      }
    );
  }

  delete_dishImage() {
    this.httpSv.delete_dishImage(this.dishes_id).subscribe((res) => {
      if (res["status"] == true) {
        this.closeModals();
        swal.fire({
          titleText: "Dish Image Deleted Successfully",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
        this.getrestoDetails();
      }
    });
  }
  delete_dishAudio() {
    this.httpSv.delete_dishAudio(this.dishes_id).subscribe((res) => {
      if (res["status"] == true) {
        this.closeModals();
        swal.fire({
          titleText: "Dish Audio Deleted Successfully",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        });
        this.getrestoDetails();
      }
    });
  }

  //  ________________________________DISH ADDON'S_________________________________________

  dish_Arrayvalue = [];
  dish_optionArray = [];
  rda_addon_id;
  rda_dish_addon_id;
  option_default;
  dataValue;
  array = [];
  option_data = [];
  empList = [];
  dishOption = [];
  Empty_addon: boolean = false;
  openModals_addon<T>(
    header: Content<T> = null,
    body: Content<T>,
    options: any = null,
    value: any
  ) {
    this.dishID = value;
    this.option_default = null;
    this.serverData = [];
    this.Empty_addon = false;

    const personsArray = this.myForm.get('persons') as FormArray;
    personsArray.clear(); // always clear first

    this.httpSv.allOptionInDish_all(value).subscribe(
      (response:any) => {
        personsArray.clear(); // clear again before refilling

        if (response?.status === true) {
          this.serverData = response.result || [];
          this.option_default = this.serverData[0]?.option_name || null;

          if (this.serverData.length > 0) {
            this.serverData.forEach((d) => {
              personsArray.push(
                this.fb.group({
                  option_name: this.option_default !== 'Default' ? d.option_name : null,
                  option_price: d.option_price ?? null,
                })
              );
            });
          } else {
            personsArray.push(
              this.fb.group({
                option_name: null,
                option_price: null,
              })
            );
          }

          this.optionsName.forEach((ele) => (this.rdo_id = ele.rdo_id));
        } else {
          personsArray.push(
            this.fb.group({
              option_name: null,
              option_price: null,
            })
          );
        }

        // open modal only after form is ready
        this.modal.open({
          body,
          header,
          options,
        });
      },
      (err) => {
        personsArray.clear();
        personsArray.push(
          this.fb.group({
            option_name: null,
            option_price: null,
          })
        );

        this.modal.open({
          body,
          header,
          options,
        });
      }
    );

    this.httpSv.addOnList().subscribe(
      (res) => {
        if (res["status"] == true) {
          this.addonListarray = res["result"].data;
          this.addonListarray = this.addonListarray.map((v) => ({
            ...v,
            dish_addon_id: v.restaurant_addon_id,
          }));
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error.message == "Addon list not found") {
          this.Empty_addon = true;
        }
      }
    );
  }

  // remove_value(i){
  // console.log(i)

  // }
  delete_option_new(index) {
    const add = this.myForm.get("persons") as FormArray;
    add.removeAt(index)
    this.serverData.splice(index, 1)
    // console.log(this.serverData,add,this.fb.group({
    //   option_name: ["", Validators.required],
    //   option_price: ["", Validators.required],
    // }))
  }
  add_value() {
    const add = this.myForm.get("persons") as FormArray;
    add.push(
      this.fb.group({
        option_name: ["", Validators.required],
        option_price: ["", Validators.required],
      })
    );
    this.serverData.push({ option_name: "", option_price: "" });
  }
  length_array;

  add_ADDon(j) {
    this.dishOption.forEach((ele) => {
      this.length_array = ele.dishOptions.length;
      if (ele.options_ids) {
        this.optionIDS = ele.options_ids;
      } else if (ele.option_ids) {
        this.optionIDS = ele.option_ids;
      }
    });
    if (this.length_array == 2) {
      this.array = [
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
      ];
    } else if (this.length_array == 3) {
      this.array = [
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
      ];
    } else if (this.length_array == 4) {
      this.array = [
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
      ];
    } else if (this.length_array == 5) {
      this.array = [
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
      ];
    } else {
      this.array = [
        {
          rdo_option_addOn_price: null,
          rdo_option_name: null,
        },
      ];
    }

    this.dataValue = {
      dishOptions: this.array,
    };
    this.dishOption.push(this.dataValue);
  }

  delete_option(id) {
    this.httpSv.deleteDishOption(id).subscribe((response) => {
      if (response["status"] == true) {
        this.optionsName_value = response["result"];
        this.httpSv.allOptionInDish_all(this.dishID).subscribe((response) => {
          if (response["status"] == true) {
            this.serverData = response["result"];
            this.serverData.forEach((ele) => {
              this.option_default = ele.option_name;
            });
            if (this.option_default != "Default") {
              if (this.serverData.length) {
                (this.myForm.controls["persons"] as FormArray).clear();
                this.serverData.map((d) =>
                  this.person.push(
                    this.fb.group({
                      option_name: d.option_name,
                      option_price: d.option_price,
                    })
                  )
                );
              } else {
                this.person.push(
                  this.fb.group({ option_name: null, option_price: null })
                );
              }
            } else {
              if (this.serverData.length) {
                (this.myForm.controls["persons"] as FormArray).clear();
                this.serverData.map((d) =>
                  this.person.push(
                    this.fb.group({
                      option_name: null,
                      option_price: d.option_price,
                    })
                  )
                );
              } else {
                this.person.push(
                  this.fb.group({ option_name: null, option_price: null })
                );
              }
            }
          }
        });
      }
    });
  }
  optionIDS;
  displayDish = [];
  placeOrderObj;
  submitClick() {
    let form_data = {
      dish_id: this.dishID,
      dish_options: this.myForm.value.persons,
    };
    this.text = 'Addons'
    this.httpSv.allAddOnInDish_get(this.dishID).subscribe(
      (res) => {
        if (res["status"] == true) {
          this.dishOption = res["result"];
          this.displayDish = this.dishOption[0].dishOptions;
          if (this.dishOption[0].option_ids) {
            this.optionIDS = this.dishOption[0].option_ids;
          } else {
            this.optionIDS = this.dishOption[0].options_ids;
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.status;
        if (this.errorMessage == false) {
        }
      }
    );
    this.httpSv.allOptionInDishs(form_data).subscribe((res) => {
      if (res["status"] == true) {
        this.httpSv.allAddOnInDish_get(this.dishID).subscribe(
          (res) => {
            if (res["status"] == true) {
              this.dishOption = res["result"];
              this.dishOption = res["result"];
              this.displayDish = this.dishOption[0].dishOptions;
              if (this.dishOption[0].option_ids) {
                this.optionIDS = this.dishOption[0].option_ids;
              } else {
                this.optionIDS = this.dishOption[0].options_ids;
              }
            }
            setTimeout(() => {
              this.httpSv.allOptionInDish_all(this.dishID).subscribe((response) => {
                if (response["status"] == true) {
                  this.serverData = response["result"];
                  this.serverData.forEach((ele) => {
                    this.option_default = ele.option_name;
                  });
                  if (this.option_default != "Default") {
                    if (this.serverData.length) {
                      (this.myForm.controls["persons"] as FormArray).clear();
                      this.serverData.map((d) =>
                        this.person.push(
                          this.fb.group({
                            option_name: d.option_name,
                            option_price: d.option_price,
                          })
                        )
                      );
                    } else {
                      this.person.push(
                        this.fb.group({ option_name: null, option_price: null })
                      );
                    }
                  } else {
                    if (this.serverData.length) {
                      (this.myForm.controls["persons"] as FormArray).clear();
                      this.serverData.map((d) =>
                        this.person.push(
                          this.fb.group({
                            option_name: null,
                            option_price: d.option_price,
                          })
                        )
                      );
                    } else {
                      this.person.push(
                        this.fb.group({ option_name: null, option_price: null })
                      );
                    }
                  }
                  this.optionsName.forEach((ele) => (this.rdo_id = ele.rdo_id));
                }
              });
              this.detectChange.detectChanges()
            }, 0)
          },
          (err: HttpErrorResponse) => {
            this.errorMessage = err.error.status;
            if (this.errorMessage == false) {
            }
          }
        );
      }
    });
  }
  updateClick() {
    let form_data = {
      dish_id: this.dishID,
      dish_options: this.myForm.value.persons,
    };
    this.closeModal()
    this.httpSv.allOptionInDishs(form_data).subscribe((res) => {
      if (res["status"] == true) {
        this.httpSv.allAddOnInDish_get(this.dishID).subscribe(
          (res) => {
            if (res["status"] == true) {
              this.text = 'Varients'
              this.closeModal()
              // this.dishOption = res["result"];
              // this.dishOption = res["result"];
              // this.displayDish = this.dishOption[0].dishOptions;
              // if (this.dishOption[0].option_ids) {
              //   this.optionIDS = this.dishOption[0].option_ids;
              // } else {
              //   this.optionIDS = this.dishOption[0].options_ids;
              // }
            }
          },
          (err: HttpErrorResponse) => {
            this.errorMessage = err.error.status;
            if (this.errorMessage == false) {
            }
          }
        );
      }
    });
  }
  backFunc() {
    this.text = 'Varients'
  }
  allAddOnInDish() {
    this.httpSv.allAddOnInDish_get(this.dishID).subscribe(
      (res) => {
        if (res["status"] == true) {
          this.dishOption = res["result"];
          this.dishOption = res["result"];
          this.displayDish = this.dishOption[0].dishOptions;
          if (this.dishOption[0].option_ids) {
            this.optionIDS = this.dishOption[0].option_ids;
          } else {
            this.optionIDS = this.dishOption[0].options_ids;
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.status;
        if (this.errorMessage == false) {
        }
      }
    );
  }

  get person() {
    return this.myForm.get("persons") as FormArray;
  }
  get features(): FormArray {
    return this.secondFormGroup.get("dishOptions") as FormArray;
  }

  priceArray = [];
  create_ADD(v) {
    v.forEach((ele) => {
      this.dish_optionArray = ele.dishOptions;
      this.rda_addon_id = ele.addon_id;
      this.rda_dish_addon_id = ele.rda_dish_addon_id;
    });
    this.dish_optionArray = this.dish_optionArray.map(
      ({ option_id, rdo_option_name, ...rest }) => ({ ...rest })
    );
    v = v.map((v) => ({
      ...v,
      rda_addon_id: v.addon_id,
    }));
    v = v.map(({ restaurant_addon_name, addon_id, ...rest }) => ({ ...rest }));
    this.dish_optionArray.forEach((ele) => {
      this.priceArray.push(ele.rdo_option_addOn_price);
    });
    let addon_Data = {
      dish_id: this.dishID,
      options_ids: this.optionIDS,
      dish_addOn_options: v,
    };
    this.httpSv.allAddOnInDish(addon_Data).subscribe(
      (res) => {
        if (res["status"] == true) {
          this.closeModals();
          this.text = 'Varients'
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        this.closeModals();
        Swal.fire(this.errorMessage);
        if (err.status == 401 || err.status == 500) {
          this.logout();
        } else if (err.status == 422) {
          Swal.fire("Add ons not created");
        } else if (err.status == 400) {
          Swal.fire(this.errorMessage);
        }
      }
    );
  }
  remove_Addon(id) {
    this.httpSv.dishAddonRemove(this.dishID, id).subscribe((res) => {
      if (res["status"] == true) {
        this.allAddOnInDish();
      }
    });
  }

  login(form) {
    this.submitted = true;
  }
  createadd: boolean = false;
  checkform(value: any) {
    this.createadd = true;
  }

  navigate_addon_page() {
    this.router.navigate(["horizontal/addon"]);
    this.closeModals();
  }
  addNewDish() {
    const popup = this.dialog.open(AddDishDialog, {
      disableClose: true,
      data: {
        isDefaultMenu: this.isDefaultMenu,
        allMenuLable: this.allMenuName,
        selectedMenu: this.selectedMenuName
      }
    })
    popup.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit()
      }
    })
  }
  openAllergenChart() {
    this.httpSv.getAllergensChart(this.restoID).subscribe((res: any) => {
      if (res['status']) {
        const dialogRef = this.dialog.open(AllergenCartDialog, {
          hasBackdrop: true,
          data: {
            apiData: res.result,
            restoID: this.restoID
          }

        })
      }
    })
  }

  openUnsutaibleDPChart() {
    this.httpSv.getUnsuitableChart(this.restoID).subscribe((res: any) => {
      if (res['status']) {
        const dialogRef = this.dialog.open(UnsutaibleDPChartDialog, {
          hasBackdrop: true,
          data: {
            apiData: res.result,
            restoID: this.restoID
          }

        })
      }
    })
  }

  showQROption = false;
  showMenuLinkOption = false;

  @ViewChild('dropdownRefQr') dropdownRefQr!: ElementRef;
  @ViewChild('dropdownRef') dropdownRef!: ElementRef;

  toggleDropdown() {
    this.showMenuLinkOption = !this.showMenuLinkOption;
  }
  toggleQrDropdown() {
    this.showQROption = !this.showQROption;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    console.log('document clicked', event.target);
    console.log(this.searchTerm, 'das')
    if (this.dropdownRef && this.dropdownRef.nativeElement) {
      if (!this.dropdownRef.nativeElement.contains(event.target)) {
        this.showMenuLinkOption = false;
      }
    }

    if (this.dropdownRefQr && this.dropdownRefQr.nativeElement) {
      if (!this.dropdownRefQr.nativeElement.contains(event.target)) {
        this.showQROption = false;
      }
    }
  }


  selectedIds = new Set<number>();
  multiSelectMode = false;
  deleteAllDish() {
    const dialogRef = this.dialog.open(DishDeleteConfirmDialog, {
      hasBackdrop: true,
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpSv.deleteMultiDish({ restaurant_id: this.restoID }).subscribe((res: any) => {
          if (res['status']) {
            this.ngOnInit()
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
          else {
            Swal.fire(this.errorMessage);
          }
        })
      }
    })
  }
  toggleMultiSelect() {
    this.multiSelectMode = !this.multiSelectMode;
    if (!this.multiSelectMode) {
      this.selectedIds.clear();
      this.restoDeatils?.forEach(r => (r._checked = false));
    }
  }

  onRowToggle(row: any, checked: boolean) {
    row._checked = checked;
    if (checked) this.selectedIds.add(row.id);
    else this.selectedIds.delete(row.id);
  }

  // Header checkbox: select/deselect only rows on the CURRENT PAGE
  toggleAllOnPage(rowsOnPage: any[], checked: boolean) {
    rowsOnPage.forEach(r => this.onRowToggle(r, checked));
  }

  areAllChecked(rowsOnPage: any[]): boolean {
    return rowsOnPage.length > 0 && rowsOnPage.every(r => !!r._checked);
  }

  isSomeChecked(rowsOnPage: any[]): boolean {
    return rowsOnPage.some(r => !!r._checked) && !this.areAllChecked(rowsOnPage);
  }
  deleteSelected() {
    const ids = Array.from(this.selectedIds);
    const dialogRef = this.dialog.open(DishDeleteConfirmDialog, {
      hasBackdrop: true,
      disableClose: true,
      data: {
        count: ids.length
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpSv.deleteMultiDish({ restaurant_id: this.restoID, dish_id: ids }).subscribe((res: any) => {
          if (res['status']) {
            this.toggleMultiSelect();
            this.ngOnInit()
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
          else {
            Swal.fire(this.errorMessage);
          }
        })
      }
    })
  }



  openFoodMenu() {
    if (this.foodMenuLink)
      window.open(this.foodMenuLink, '_blank')
    else
      Swal.fire("Restaurant table is not active");
  }

  copyFoodMenuLink() {
    if (this.foodMenuLink) {
      navigator.clipboard.writeText(this.foodMenuLink).then(() => {
        Swal.fire("Copied to clipboard");
      });
    } else {
      Swal.fire("Restaurant table is not active");
    }
  }

  addMenuName() {
    const popup = this.dialog.open(AddMenuNameDialog, {
      disableClose: true,
      data: {
        isExistingDish: this.allMenuName.length > 0 ? true : false,
        restoID: this.restoID,
        allMenuName: this.allMenuName,
      }
    })
    popup.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit()
      }
    })
  }

  showMenu(){
    this.httpSv.getAllMenu(this.restaurant_id, this.tableId).subscribe((res:any) => {
      if(res['status']){
        const data = res['result'].data[0]
        this.dialog.open(MenuLayoutComponent, {
          data: data
        })
      }
      else{
        this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
      }
    },(err:any) => {
      this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
    })
  }

}




@Component({
  selector: "add-dish-dialog",
  templateUrl: "./new-dish-add-dialog.html",
})
export class AddDishDialog implements OnInit {
  constructor
    (
      private dialogRef: MatDialogRef<AddDishDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private httpSv: HttpService,
      private toster: ToastrService
    ) { }
  ngOnInit(): void {
    this.restoID = localStorage.getItem('restoID')
    this.getAllAllergens()
    this.getAllDietPref()
    this.getAllCategorie()
    this.getAllTags()
    if (!this.data.isDefaultMenu) {
      this.allMenuLabel = this.data.allMenuLable
      this.isDefaultMenu = this.data.isDefaultMenu
      this.selectedMenu = this.data.selectedMenu
    }
  }

  allMenuLabel: any = []
  isDefaultMenu: any = true
  selectedMenu: any = ''

  dishName = ''
  dishPrice = ''
  dishCalories = ''
  ingredient = ''
  description = ''








  allergenApiData = []
  dietPrefApiData = []
  restoID

  compareFn(item, selected) {
    console.log("ITEM", item);
    console.log("SELECTED", selected);
    return item.value === selected.value;
  }


  // spice rating
  spiceRating = [
    { spice_rating: 0 },
    { spice_rating: 1 },
    { spice_rating: 2 },
    { spice_rating: 3 },
    { spice_rating: 4 }
  ]
  spicerating: any = null
  spiceRatingChangeHandeler(event) {

  }
  //Categories

  categories = []
  cats: any = null
  catsChangeHandeler(event) {

  }
  getAllCategorie() {
    this.httpSv.getallActiveCategory(this.restoID).subscribe(res => {
      if (res['status'] == true) {
        this.categories = res['result'].data
      }
    })
  }


  //allergens

  allergens = []
  algns: any = []
  finalAllergenData = []
  algnChangeHandeler(event) {
    this.finalAllergenData = []
    if (((event.length > 0) && (event[event.length - 1].allergens_id == 0)) || ((event.length == 2) && (event[0].allergens_id == 0))) {
      this.algns.splice(0)
      this.algns = [event[event.length - 1].allergens_id]
      this.finalAllergenData.push({ allergens_id: event[event.length - 1].allergens_id })
    }
    else {
      event.forEach(ele => {
        this.finalAllergenData.push({ allergens_id: ele.allergens_id })
      });
    }
  }
  getAllAllergens() {
    this.httpSv.getallActiveRestoAllergens().subscribe(res => {
      if (res['status'] == true) {
        this.allergenApiData = res['result'].data
        this.allergens = JSON.parse(JSON.stringify(this.allergenApiData))
        this.getAllAllergenOp()
      }
    })
    return (
      this.allergens = [{ id: 0, name: 'Undifine' }]
    )
  }

  //unsuitable diet pref

  allUsDietPref = []
  SelectedUsDietPref: any = []
  finalUsDietPref = []
  usDietPrefChangeHandeler(event) {
    this.finalUsDietPref = []
    if (((event.length > 0) && (event[event.length - 1].diet_preference_id == 0)) || (event.length == 2) && (event[0].diet_preference_id == 0)) {
      this.SelectedUsDietPref.splice(0)
      this.SelectedUsDietPref = [event[event.length - 1].diet_preference_id]
      this.finalUsDietPref.push({ diet_preference_id: event[event.length - 1].diet_preference_id })
    }
    else {
      event.forEach(ele => {
        this.finalUsDietPref.push({ diet_preference_id: ele.diet_preference_id })
      });
    }
  }
  getAllDietPref() {
    this.httpSv.getallActiveRestoDiestpref().subscribe(res => {
      if (res['status'] == true) {
        this.dietPrefApiData = res['result'].data
        this.allUsDietPref = JSON.parse(JSON.stringify(this.dietPrefApiData))
        this.getAllStDietPref()
        this.getAllAoDietPref()
      }
    })
    return (this.allUsDietPref = [{ id: 0, name: 'undefine' }])
  }


  //suitable diet pref
  allStDietPref = []
  SelectedStDietPref: any = []
  finalStDietPref = []
  stDietPrefChangeHandeler(event) {
    this.finalStDietPref = []
    if (((event.length > 0) && (event[event.length - 1].diet_preference_id == 0)) || (event.length == 2) && (event[0].diet_preference_id == 0)) {
      this.SelectedStDietPref.splice(0)
      this.SelectedStDietPref = [event[event.length - 1].diet_preference_id]
      this.finalStDietPref.push({ diet_preference_id: event[event.length - 1].diet_preference_id })
    }
    else {
      event.forEach(ele => {
        this.finalStDietPref.push({ diet_preference_id: ele.diet_preference_id })
      });
    }
  }
  getAllStDietPref() {
    this.allStDietPref = JSON.parse(JSON.stringify(this.dietPrefApiData))
  }

  //Allergens options
  allAllergenOp = []
  SelectedAllergenOp: any = []
  finalAllergenOp = []
  allergenOpChangeHandeler(event) {
    this.finalAllergenOp = []
    if (((event.length > 0) && (event[event.length - 1].allergens_id == 0)) || (event.length == 2) && (event[0].allergens_id == 0)) {
      this.SelectedAllergenOp.splice(0)
      this.SelectedAllergenOp = [event[event.length - 1].allergens_id]
      this.finalAllergenOp.push({ allergens_id: event[event.length - 1].allergens_id })
    }
    else {
      event.forEach(ele => {
        this.finalAllergenOp.push({ allergens_id: ele.allergens_id })
      });
    }

  }
  getAllAllergenOp() {
    this.allAllergenOp = JSON.parse(JSON.stringify(this.allergenApiData))
  }

  //Diet pref available option
  allAoDietPref = []
  SelectedAoDietPref: any = []
  finalAoDietPref = []
  aoDietPrefChangeHandeler(event) {
    this.finalAoDietPref = []
    if (((event.length > 0) && (event[event.length - 1].diet_preference_id == 0)) || ((event.length == 2) && (event[0].diet_preference_id == 0))) {
      this.SelectedAoDietPref.splice(0)
      this.SelectedAoDietPref = [event[event.length - 1].diet_preference_id]
      this.finalAoDietPref.push({ diet_preference_id: event[event.length - 1].diet_preference_id })
    }
    else {
      event.forEach(ele => {
        this.finalAoDietPref.push({ diet_preference_id: ele.diet_preference_id })
      });
    }

  }
  getAllAoDietPref() {
    this.allAoDietPref = JSON.parse(JSON.stringify(this.dietPrefApiData))
  }
  //Tags
  allTags = []
  SelectedTags: any = []
  finalTags = []
  tagsChangeHandeler(event) {
    this.finalTags = []
    event.forEach(ele => {
      this.finalTags.push({ tag_id: ele.tag_id })
    });
  }
  getAllTags() {
    this.httpSv.getTag().subscribe(res => {
      if (res['status'] == true) {
        this.allTags = res['result'].data
      }
    })
  }


  close() {
    this.dialogRef.close(false)
  }
  addDishFunc() {
    if (this.dishName != '') {
      if (this.dishPrice != '') {
        if (this.cats) {
          if (this.ingredient != '') {
            let data = {
              restaurant_id: localStorage.getItem('restoID'),
              dish_type_id: this.cats,
              name: this.dishName,
              ingredients: this.ingredient,
              price: this.dishPrice,
            }
            if (this.description != '') data['description'] = this.description
            if (this.dishCalories != '') data['calories'] = this.dishCalories
            if (this.spicerating) data['spice_rating'] = this.spicerating
            if (this.finalAllergenData.length > 0) data['allergens'] = this.finalAllergenData
            if (this.finalUsDietPref.length > 0) data['unsuitable_dietary'] = this.finalUsDietPref
            if (this.finalStDietPref.length > 0) data['suitable_dietary'] = this.finalStDietPref
            if (this.finalTags.length > 0) data['taglist'] = this.finalTags
            if (this.finalAllergenOp.length > 0) data['allergens_option_available'] = this.finalAllergenOp
            if (this.finalAoDietPref.length > 0) data['dietry_preference_option'] = this.finalAoDietPref
            if (this.isDefaultMenu) data['menu_label_id'] = 1;
            else data['menu_label_id'] = this.selectedMenu

            this.httpSv.addNewDish(data).subscribe(res => {
              if (res['status'] == true) {
                this.toster.success('New dish added', '', {
                  timeOut: 3000
                })
                this.dialogRef.close(true)
              }
            }, err => {
              if (err.status == 500) {
                this.toster.error('Oops!! Something went wrong', '', {
                  timeOut: 3000
                })
              }
              else {
                this.toster.error(err.error.message, '', {
                  timeOut: 3000
                })
              }
            })
          }
          else {
            this.toster.error('Please fill ingredient detail', '', {
              timeOut: 3000
            })
          }
        }
        else {
          this.toster.error('Please select category type', '', {
            timeOut: 3000
          })
        }
      }
      else {
        this.toster.error('Please fill price of dish', '', {
          timeOut: 3000
        })
      }
    }
    else {
      this.toster.error('Please fill the dish name', '', {
        timeOut: 3000
      })
    }

  }
}

// import html2canvas from 'html2canvas';
// import * as html2pdf from 'html2pdf.js';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
import autoTable from 'jspdf-autotable'
import jsPDF from 'jspdf';
import { MenuLayoutComponent } from "../menu-layout/menu-layout.component";

@Component({
  selector: "allergen-chart-dialog",
  templateUrl: "./allergen_chart_dialog.html",
})
export class AllergenCartDialog implements OnInit {
  constructor
    (
      private dialogRef: MatDialogRef<AllergenCartDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private httpSv: HttpService,
      private toster: ToastrService,
      private pdfService: PdfServiceService,
      private dialog: MatDialog,
      private renderer: Renderer2
    ) { }
  ngOnInit(): void {
    this.allergensData = this.data.apiData.restaurant_allergens;
    this.dishesData = this.data.apiData.dishes
    this.reviewedBy = this.data.apiData.restaurant_reviewed_details
    this.restoID = this.data.restoID
    this.getAllCategorie()
  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    const ele: any = document.getElementsByClassName('myfavourite_table')
    if (ele) {
      ele[0].style.borderCollapse = 'collapse'
      setTimeout(() => {
        ele[0].style.borderCollapse = 'separate'
      }, 500)
    }
  }
  downloadFlag: boolean = false
  @ViewChild('content', { static: false }) content: ElementRef;
  // public downloadPdf(): void {
  //   this.downloadFlag = true
  //   setTimeout(() => {
  //     const contentElement = this.content.nativeElement;

  //     // Add a class for PDF export
  //     this.renderer.addClass(contentElement, 'pdf-export');
  //     const options = {
  //       margin: 8,
  //       filename: 'download.pdf',
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { scale: 2, scrollY: -window.scrollY }, // Adjust scrollY if needed
  //       jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
  //     };

  //     html2pdf()
  //       .from(contentElement)
  //       .set(options)
  //       .save()
  //       .catch(err => console.error('Error generating PDF', err))
  //       .finally(() => {
  //         // Remove the class after generating the PDF
  //         this.renderer.removeClass(contentElement, 'pdf-export');
  //         this.downloadFlag = false
  //         document.body.click()
  //       });
  //   }, 10)

  // }


  downloadPdf() {
    this.downloadFlag = true
    setTimeout(() => {
      let headers = ['Dishes']
      let allergenHeader = this.allergensData.map((ele) => ele.allergens_name)
      headers = [...headers, ...allergenHeader]
      let tableData = []
      this.dishesData.forEach(element => {
        let data = {
          dishes: element.name
        }
        this.allergensData.forEach(allergen => {
          if (this.allergensExist(element.allergens, allergen)) {
            if (this.getOptionAvailabel(element.allergens, allergen))
              data[allergen.allergens_name.toLowerCase().replace(' ', '')] = 'Y/oa'
            else
              data[allergen.allergens_name.toLowerCase().replace(' ', '')] = 'Y'
          } else {
            data[allergen.allergens_name.toLowerCase().replace(' ', '')] = ''
          }
        });
        tableData.push(data)
      });

      const bodyData = tableData.map(row =>
        headers.map(header => {
          const cellKey = header.toLowerCase().replace(' ', ''); // Convert header to key
          const cellData = row[cellKey]; // Access data based on dynamic header
          return cellData && cellData == 'Y/oa' ? { image: cellData, optionAv: true, width: 10, height: 10 } : cellData && cellData == 'Y' ? { image: cellData, width: 10, height: 10 } : cellData; // Handle image URLs
        })
      );
      const doc = new jsPDF('landscape', 'mm', 'a4');
      const imgData = '../../../assets/img/6.png';
      const tickImgData = '../../../assets/img/allegen_icons_check-mark.png';
      doc.addImage(imgData, 'PNG', 10, 10, 20, 20); // Adjust positioning and size
      doc.setFontSize(9);
      doc.text('You can find this template, including more information at', 160, 20); // Adjust positioning
      doc.setTextColor(0, 0, 255);
      doc.textWithLink('www.food.gov.uk/aalergy-guidance', 240, 20, { url: 'https://www.food.gov.uk/aalergy-guidance' });




      let pageCount = 0
      let startY = 30;
      let diParseRef: any
      autoTable(doc, {
        margin: { top: 10, left: 5, right: 5, bottom: 0 },
        head: [headers],
        body: bodyData,
        didParseCell: (data: any) => {
          const { cell } = data;
          cell.styles.minCellHeight = 15;
          if (data.cell.raw && data.cell.raw.image) {
            data.cell.text = '';
          }
        },
        didDrawCell: (data: any) => {
          diParseRef = data
          if (data.cell.raw && data.cell.raw.image) {
            const imageData = tickImgData;  // Your image data
            const { cell } = data;

            if (cell.width > 0 && cell.height > 0) {
              const imgWidth = 5; // Adjust image width
              const imgHeight = 5; // Adjust image height
              const padding = 2; // Padding between image and text
              const xOffset = cell.x + (cell.width - imgWidth) / 2; // Center the image horizontally
              const yOffset = cell.y + (cell.height - imgHeight) / 2; // Center the image vertically

              // Add the image to the cell
              doc.addImage(imageData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);
              if (data.cell.raw.optionAv) {
                // Add the text "(O/A)" below the image
                const text = '(O/A)';
                const textX = cell.x + (cell.width - doc.getStringUnitWidth(text) * doc.internal.scaleFactor) / 2; // Center the text horizontally
                const textY = yOffset + imgHeight + padding; // Position text below the image with some padding

                // Ensure text is within cell boundaries
                const textMaxWidth = cell.width - 2 * padding;
                doc.setFontSize(6);
                doc.setTextColor(0, 0, 0); // Set text color

                // Check if text fits within the cell width
                if (doc.getStringUnitWidth(text) * doc.internal.scaleFactor > textMaxWidth) {
                  // Text might need to be truncated or adjusted if too wide
                  // Here, you might handle text overflow or apply different styling
                }

                doc.text(text, textX, textY);
              }
            }
          }
        },
        startY: 30,
        theme: 'grid',
        pageBreak: 'auto',


      });





      let footerText = 'Note: (O/A) indicates Option Available';
      const pageHeight = doc.internal.pageSize.height;

      // Check if there is enough space for the footer text
      const remainingSpace = pageHeight - diParseRef.cursor.y - 10; // 10mm margin at the bottom
      if (remainingSpace < doc.getFontSize() * 2) { // Check if space is less than required height
        doc.addPage(); // Add a new page if needed
        doc.setTextColor(0, 0, 0); // Black color for the text
        doc.text(footerText, 10, 20); // Position footer text on the new page
        doc.setFontSize(14);
        doc.text(`Review Date: ${this.formatDate(this.reviewedBy[0].reviewed_date)}                       Reviewed By: ${this.reviewedBy[0].reviewed_by ? this.reviewedBy[0].reviewed_by : 'N/A'}`, 10, 30);
      } else {
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0); // Black color for the text
        doc.text(footerText, 10, diParseRef.cursor.y + 10); // Position the additional text
        if (remainingSpace > 40) {
          doc.setFontSize(14);
          doc.text(`Review Date: ${this.formatDate(this.reviewedBy[0].reviewed_date)}                       Reviewed By: ${this.reviewedBy[0].reviewed_by ? this.reviewedBy[0].reviewed_by : 'N/A'}`, 10, diParseRef.cursor.y + 20);
        } else {
          doc.addPage(); // Add a new page if needed
          doc.setTextColor(0, 0, 0); // Black color for the text
          doc.setFontSize(14);
          doc.text(`Review Date: ${this.formatDate(this.reviewedBy[0].reviewed_date)}                       Reviewed By: ${this.reviewedBy[0].reviewed_by ? this.reviewedBy[0].reviewed_by : 'N/A'}`, 10, 20);
        }
      }


      let fileName = this.categories.filter((ele: any) => ele.dish_type_id == this.food_dishes_category_id)

      doc.save(`${fileName[0].dish_type_name}_Allergen_Chart.pdf`);
      this.downloadFlag = false
    }, 10)
  }
















  restoID: any
  allergensData: any = []
  dishesData: any = []
  reviewedBy: any = []
  food_dishes_category_id: any = 0;
  categories: any = [
    {
      dish_type_id: 0,
      dish_type_name: 'All'
    }
  ];
  categoriesChangeHandler() {
    console.log(this.food_dishes_category_id)
    if (this.food_dishes_category_id == 0) {
      this.httpSv.getAllergensChart(this.restoID).subscribe((res: any) => {
        if (res['status']) {
          this.dishesData = res.result['dishes']
        }
      })
    }
    else {
      this.httpSv.getAllergensChart(this.restoID, this.food_dishes_category_id).subscribe((res: any) => {
        if (res['status']) {
          this.dishesData = res.result['dishes']
        }
      })
    }
  }
  allergensExist(dishAllergens: any, boxAllergens: any) {
    if (dishAllergens.some((obj: any) => obj.allergens_id == boxAllergens.allergens_id))
      return true
    else
      return false
  }
  getOptionAvailabel(dishAllergens: any, boxAllergens: any) {
    let ind = dishAllergens.findIndex((obj: any) => obj.allergens_id == boxAllergens.allergens_id)
    if (ind != -1) {
      return dishAllergens[ind].is_allergens_option
    }
    else return 0
  }
  openReviewInfoDialog() {
    const dilogRef = this.dialog.open(ReviewedByDialog, {
      hasBackdrop: true,
      data: this.reviewedBy
    })
    dilogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.reviewedBy = res
      }
    })
  }
  formatDate(epoch: any) {
    if (epoch) {
      const date = new Date(epoch * 1000); // Convert epoch to milliseconds
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    }
    else return 'N/A'
  }
  getAllCategorie() {
    this.httpSv.getallActiveCategory(this.restoID).subscribe(res => {
      if (res['status'] == true) {
        this.categories = [...this.categories, ...res['result'].data]
      }
    })
  }
}


@Component({
  selector: "reviewed-by-dialog",
  templateUrl: "./reviewed_by_dialog.html",
})
export class ReviewedByDialog implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ReviewedByDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpSv: HttpService,
    private toster: ToastrService,
  ) { }
  ngOnInit(): void {
    this.restoID = localStorage.getItem("restoID");
    this.reviewed_by_name = this.data[0].reviewed_by
    this.review_date = this.formatDate(this.data[0].reviewed_date)
  }
  restoID: any
  reviewed_by_name: any
  review_date: any
  updateReviewData() {
    if (this.reviewed_by_name != '' && this.reviewed_by_name) {
      if (this.review_date != '' && this.review_date) {
        const date = new Date(this.review_date);

        // Convert the date to an epoch timestamp (in seconds)
        const epochTime = Math.floor(date.getTime() / 1000);
        const data = {
          'restaurant_id': this.restoID,
          'reviewed_by': this.reviewed_by_name,
          'reviewed_date': epochTime
        }
        this.httpSv.updateReviewByDtls(data).subscribe((res: any) => {
          if (res['status']) {
            this.toster.success('Updated Successfully', '', { timeOut: 2000 })
            this.dialogRef.close([{
              'reviewed_by': this.reviewed_by_name,
              'reviewed_date': epochTime
            }])
          } else {
            this.toster.error('Oops! Something went wrong', '', { timeOut: 2000 })
            this.dialogRef.close(false)
          }
        }, (err: any) => {
          this.toster.error('Oops! Something went wrong', '', { timeOut: 2000 })
          this.dialogRef.close(false)
        })
      } else {
        this.toster.error('Please Enter The Reviewed Date')
      }
    } else {
      this.toster.error('Please Enter The Reviewed By Name')
    }
  }
  formatDate(epoch: any) {
    if (epoch) {
      const date = new Date(epoch * 1000); // Convert epoch to milliseconds
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    }
    else return null
  }
}







@Component({
  selector: "add-menu-name-dialog",
  templateUrl: "./add_menu_name_dialog.html",
})
export class AddMenuNameDialog implements OnInit {

  constructor
    (
      private dialogRef: MatDialogRef<AddMenuNameDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private httpSv: HttpService,
      private toster: ToastrService,
      private modal: TCModalService,
    ) { }
  ngOnInit(): void {
    this.isExistingDish = this.data.isExistingDish
    this.allMenuName = this.data.allMenuName
    this.allMenuName.forEach((ele: any) => { ele['isEdit'] = false })
  }

  isExistingDish: any = true
  existingDishLabel: any = null
  newDishLabel: any = null
  hideLabel: boolean = false

  selectedToggle: string = 'add'

  allMenuName: any = []

  close() {
    this.dialogRef.close(this.isStatusChnages ? true : false)
  }

  addLabels() {
    let payload = {
      restaurant_id: this.data.restoID,
      isExistingDish: (!this.isExistingDish).toString()
    }
    if (!this.isExistingDish) {
      if (!this.existingDishLabel || this.existingDishLabel == '') {
        this.toster.info('Please Enter Existing Dish Label', '', { timeOut: 2000 })
        return
      }
      payload['old_dish_label'] = this.existingDishLabel
    }
    if (!this.newDishLabel || this.newDishLabel == '') {
      this.toster.info('Please Enter New Dish Label', '', { timeOut: 2000 })
      return
    }
    payload['new_dish_label'] = this.newDishLabel

    console.log(this.hideLabel)
    payload['hide_label'] = this.hideLabel ? 'true' : 'false'

    this.httpSv.addMenuName(payload).subscribe((res: any) => {
      if (res['status'] == true) {
        this.toster.success('Labels Added Successfully', '', { timeOut: 2000 })
        this.dialogRef.close(true)
      }
      else {
        this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
      }
    }, (err: any) => {
      this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
    })

  }

  maenuLabelToggle(val: string) {
    this.selectedToggle = val
  }

  updateMenuLabelName(data: any) {
    if (!data.dish_menu_name || data.dish_menu_name == '') {
      return this.toster.info('Please Enter Menu Label Name', '', { timeOut: 2000 })
    }

    const payload = {
      menu_label_id: data.id,
      menu_label_name: data.dish_menu_name,
    }

    this.httpSv.updateMenuLabelName(payload).subscribe((res: any) => {
      if (res['status'] == true) {
        this.toster.success('Labels Updated Successfully', '', { timeOut: 2000 })
        this.dialogRef.close(true)
      }
      else {
        this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
      }
    }, (err: any) => {
      this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
    })
  }


  deleteFlag: boolean = false
  deleteData = null



  deleteMenuLabel(menu_label) {
    this.deleteData = menu_label
    this.deleteFlag = true
  }
  cancelDelete() {
    this.deleteFlag = false
    this.deleteData = null
  }
  deleteLabel() {
    const payload = {
      restoId: this.data.restoID,
      menu_label_id: this.deleteData.id
    }
    this.httpSv.deleteMenuLabel(payload).subscribe((res: any) => {
      if (res['status'] == true) {
        this.toster.success('Labels Deleted Successfully', '', { timeOut: 2000 })
        this.dialogRef.close(true)
      }
      else {
        this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
      }
    }, (err: any) => {
      this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
    })
  }


  isStatusChnages: boolean = false

  onStatusToggle(item: any, nextChecked: boolean) {
    if (item._busy) return;
    const prevChecked = item.dish_menu_status === 'Active';
    if (prevChecked === nextChecked) return;

    const nextStatus = nextChecked ? 'Active' : 'Inactive';
    item._busy = true;

    const data = {
      menu_label_id: item.id,
      menu_label_status: nextStatus,
    }

    this.httpSv.updateReturantMenuNameStatus(data).subscribe((res: any) => {
      if (res['status'] == true) {
        this.toster.success('Status Updated Successfully', '', { timeOut: 2000 })
        this.isStatusChnages = true;
        item.dish_menu_status = nextStatus;
        // this.dialogRef.close(true)
        item._busy = false;
      }
      else {
        item._busy = false;
        this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
      }
    }, (err: any) => {
      item._busy = false;
      this.toster.error('Something Went Wrong', '', { timeOut: 2000 })
    })
  }
}



@Component({
  selector: "dish-delete-confirm-dialog",
  templateUrl: "./dish_delete_confirm_dialog.html",
  encapsulation: ViewEncapsulation.None
})
export class DishDeleteConfirmDialog implements OnInit {

  constructor
    (
      private dialogRef: MatDialogRef<DishDeleteConfirmDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
  count: any
  ngOnInit() {
    if (this.data?.count) {
      this.count = this.data.count
    }
  }

  close(flag: boolean) {
    this.dialogRef.close(flag)
  }
}
















@Component({
  selector: "unsutaible-chart-dialog",
  templateUrl: "./unsutaible_dp_chart.html",
})
export class UnsutaibleDPChartDialog implements OnInit {
  constructor
    (
      private dialogRef: MatDialogRef<UnsutaibleDPChartDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private httpSv: HttpService,
      private toster: ToastrService,
      private pdfService: PdfServiceService,
      private dialog: MatDialog,
      private renderer: Renderer2
    ) { }
  ngOnInit(): void {
    this.allergensData = this.data.apiData.diet_preferences;
    this.dishesData = this.data.apiData.dishes
    // this.reviewedBy = this.data.apiData.restaurant_reviewed_details
    this.restoID = this.data.restoID
    this.getAllCategorie()
  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    const ele: any = document.getElementsByClassName('myfavourite_table')
    if (ele) {
      ele[0].style.borderCollapse = 'collapse'
      setTimeout(() => {
        ele[0].style.borderCollapse = 'separate'
      }, 500)
    }
  }
  downloadFlag: boolean = false
  @ViewChild('content', { static: false }) content: ElementRef;


  restoID: any
  allergensData: any = []
  dishesData: any = []
  reviewedBy: any = []
  food_dishes_category_id: any = 0;
  categories: any = [
    {
      dish_type_id: 0,
      dish_type_name: 'All'
    }
  ];
  categoriesChangeHandler() {
    console.log(this.food_dishes_category_id)
    if (this.food_dishes_category_id == 0) {
      this.httpSv.getUnsuitableChart(this.restoID).subscribe((res: any) => {
        if (res['status']) {
          this.dishesData = res.result['dishes']
        }
      })
    }
    else {
      this.httpSv.getUnsuitableChart(this.restoID, this.food_dishes_category_id).subscribe((res: any) => {
        if (res['status']) {
          this.dishesData = res.result['dishes']
        }
      })
    }
  }
  allergensExist(dishAllergens: any, boxAllergens: any) {
    if (dishAllergens.some((obj: any) => obj.dp_id == boxAllergens.dp_id))
      return true
    else
      return false
  }
  getOptionAvailabel(dishAllergens: any, boxAllergens: any) {
    let ind = dishAllergens.findIndex((obj: any) => obj.dp_id == boxAllergens.dp_id)
    if (ind != -1) {
      return 1
      return dishAllergens[ind].is_allergens_option
    }
    else return 0
  }
  openReviewInfoDialog() {
    const dilogRef = this.dialog.open(ReviewedByDialog, {
      hasBackdrop: true,
      data: this.reviewedBy
    })
    dilogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.reviewedBy = res
      }
    })
  }
  formatDate(epoch: any) {
    if (epoch) {
      const date = new Date(epoch * 1000); // Convert epoch to milliseconds
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    }
    else return 'N/A'
  }
  getAllCategorie() {
    this.httpSv.getallActiveCategory(this.restoID).subscribe(res => {
      if (res['status'] == true) {
        this.categories = [...this.categories, ...res['result'].data]
      }
    })
  }
}
